// Copyright ©️ 2026 eVolve MEP, LLC

import { Switch, Table } from '@mantine/core';

import type { WithRequired } from 'helpers/helper-types';

export const NotificationSettingsToggleRow = (props: WithRequired<Switch.Props, 'label'>) => (
  <Table.Tr p="md">
    <Table.Td>
      <Switch labelPosition="left" styles={{ body: { justifyContent: 'space-between' } }} {...props} />
    </Table.Td>
  </Table.Tr>
);
